import type { VFC, CSSProperties } from 'react';
import styled from 'styled-components';
import { Spin, type SpinProps } from 'antd';
import { Icon } from '@/components/icon';

type SpinnerWheelProps = Pick<SpinProps, 'size' | 'className' | 'style' | 'prefixCls'>;

interface StyledContaineredSpinnerProps {
  justify?: CSSProperties['justifyContent'];
  padding?: number;
}

export type SpinnerProps = SpinnerWheelProps & StyledContaineredSpinnerProps;

const SpinnerWheel: VFC<SpinnerWheelProps> = ({ size = 'large', ...options }) => (
  <Spin indicator={<Icon iconString="spinner" spin />} size={size} {...options} />
);

const StyledSpinnerContainer = styled.div<StyledContaineredSpinnerProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: ${({ padding }) => padding || 0}px;
  justify-content: ${({ justify }) => justify};
`;

export const Spinner: VFC<SpinnerProps> = ({ justify = 'center', padding = 48, ...options }) => (
  <StyledSpinnerContainer justify={justify} padding={padding}>
    <SpinnerWheel {...options} />
  </StyledSpinnerContainer>
);
